import React, { useState, useEffect, useRef } from 'react'
import { Icon } from '@iconify/react/dist/iconify.js';
import "react-datepicker/dist/react-datepicker.css";
import LottieLoading from '../../components/child/LottieLoading';
import { PostFormDataByAgg } from '../../utils/axios';
import ModalAlert from '../../components/ModalAlert';

const UploadBAForm = ({ open, mode, upload, handleClose , refreshData, roleCode}) => {
  const [isLoading,setIsLoading] = useState(false)
  const [modal, setModal] = useState(<div></div>);

  const [musicLabelCode, setMusicLabelCode] = useState("");
  const [labels, setLabels] = useState([]); 
  const [status, setStatus] = useState("");
  const [notes, setNotes] = useState("");
  const [documentNo, setDocumentNo] = useState("");
  const [documentCode, setDocumentCode] = useState("");
  const [updatedBy, setUpdatedBy] = useState("admin@gmail.com");
  const [file, setFile] = useState(null);

  const fileInputRef = useRef();

  useEffect(() => {
    if (upload && upload.original) {
      setMusicLabelCode(upload.original.music_label_code || "");
      setStatus(upload.original.status_name || "");
      setNotes(upload.original.description || "");
      setDocumentNo(upload.original.document_no || "");
      setDocumentCode(upload.original.document_code || "");
      setLabels([
      { code: upload.original.music_label_code, name: upload.original.music_label_name }
    ]);
    }
  }, [upload]);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0]
    setFile(selectedFile);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData();
    formData.append("music_label_code", musicLabelCode);
    formData.append("status", status);
    formData.append("notes", notes);
    formData.append("document_code", documentCode);
    formData.append("updated_by", updatedBy);
    if (file) formData.append("file", file);

    PostFormDataByAgg({
      url: "label/lm/v1/document/upload",
      body: formData,
      onResponse: onResponseUpload,
      onError: onResponseErrorUpload,
    });
  }

   // ==== RESPONSE HANDLERS ====
  function onResponseUpload(response) {
    console.log("Response from create:", response.data)
    setIsLoading(false);
    if(response.data.code === "2002000"){
      setModal(
        <ModalAlert
          show={true}
          type={"success"}
          text={response.data.message.id}
          action={() => {
            setModal(<div></div>);
            refreshData();
            handleClose();
          }}
        />
      )
    }
  }

  function onResponseErrorUpload(error) {
    console.log("error from create:", error.response.data)
    setIsLoading(false);
    if(error.response.data.code === "4003400"){
      setModal(
        <ModalAlert
          show={true}
          type={"failed"}
          text={error.response.data.message.id}
          action={() => {
            handleClose();
          }}
        />
      )
    }
  }

  return (
    <div className={`modal fade ${open ? "show" : ""}`} tabIndex="-1" style={{ display: open ? "block" : "none" }} aria-hidden={!open}>
      <div className="modal-dialog modal-dialog-centered modal-lg" >
        <div className="modal-content">
          <div className="modal-header justify-content-between" style={{
            background: "rgba(192, 219, 255, 0.45)", 
            backdropFilter: "blur(90px)", 
            color: "black",
            padding: "20px",
            borderRadius: "12px",
          }}>
            <h5 className="modal-title">
              {mode === 'create' ? 'Create Document' : 
               mode === 'upload' ? 'Upload Document' : 
               mode === 'update' ? 'Update Document' : 'Delete Document'}
            </h5>
            <button type="button" className="close" onClick={handleClose}>
              <Icon icon="mdi:close-circle" width={24} height={24} />
            </button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Music Label Code</label>
                    <select
                        className="form-select"
                        value={musicLabelCode}
                        onChange={(e) => setMusicLabelCode(e.target.value)}
                        required
                        readOnly
                    >
                        <option value="">Select Music Label</option>
                        {labels.map((label, idx) => (
                        <option key={idx} value={label.code}>
                            {label.name}
                        </option>
                        ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Notes</label>
                    <input 
                      type="text" 
                      className="form-control"
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Updated By</label>
                    <input 
                      type="text" 
                      className="form-control"
                      value={updatedBy}
                      onChange={(e) => setUpdatedBy(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select 
                      className="form-select" 
                      value={status} 
                      onChange={(e) => setStatus(e.target.value)} 
                      required
                    >
                      <option value="">Select Status</option>
                     { (roleCode === "RL2411111120977") ? (
                         <>
                         <option value="RECEIVED">RECEIVED</option>
                         <option value="RESENT">RESENT</option>
                        </>
                        ) : (
                        <>
                            <option value="SENT">SENT</option>
                            <option value="DRAFT">DRAFT</option>
                            <option value="APPROVED">APPROVED</option>
                            <option value="RETURNED">RETURNED</option>
                        </>
                        )}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">No Document</label>
                    <input 
                      type="text" 
                      className="form-control"
                      value={documentNo}
                      onChange={(e) => setDocumentNo(e.target.value)}
                      required
                      readOnly
                    />
                    <input 
                        type="hidden"
                        name="document_code"
                        value={documentCode}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Choose File</label>
                    <input
                      required
                      type="file"
                      className="form-control"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
              </div>

              <div className="text-center mt-4">
                <button className="btn btn-primary cursor-pointer" type='submit'>
                  <i className="ri-upload-cloud-line me-2"></i>
                  Upload
                </button>
              </div>        
            </form>
          </div>
          {isLoading && <LottieLoading text='Processing...' />}
          {modal}
        </div>
      </div>
    </div>
  )
}

export default UploadBAForm
